<button class="btn-option" id="btn-options" (click)="openModal()" [matMenuTriggerFor]="beforeMenu">
  <img src="../../../../assets/svgs/{{ options.iconLeft }}.svg" alt="Agenda">
  <p class="description">{{ options.listOptions[countOption] }}</p>
  <img class="arrow" src="../../../../assets/svgs/{{ options.iconRight }}.svg" [ngClass]="{'open': showModal}"
    alt="Seta" *ngIf="options.isIcon">
</button>

<mat-menu #beforeMenu="matMenu" xPosition="before">
  <div class="item-hover" *ngFor="let item of options.listOptions; let i = index">
    <button (click)="sendOption(item, i)" id="btn-select-option-{{i}}" mat-menu-item>{{ item }}</button>
  </div>
</mat-menu>

